<script setup lang="ts">
import type { defaultSideItemProps } from '@/types/appTypes'

const props = withDefaults(defineProps<defaultSideItemProps>(), {})

const storeIndex = useStoreIndex()
const storeUser = useStoreUser()

const onClickDetail = () => {
  const to = { path: `/gakugeiin/${props.item.article_slug}` }
  if (storeUser.state.isLogin) {
    navigateTo(to)
  } else {
    storeUser.setLoginRedirectPath(to)
    navigateTo('/login')
  }
}
</script>

<template>
  <div class="c-gakugeiinSideItem">
    <div
      class="c-gakugeiinSideItem_content c-clampLines is-clampline3"
      v-on:click="onClickDetail()"
    >
      {{ item.title }}
      ［{{ item.custom.location }}］
    </div>
    <div
      class="c-gakugeiinSideItem_location"
    >
      {{ storeIndex.getPrefName(item.custom.jis_no) }}
    </div>
  </div>
</template>

<style lang = "scss" scoped>
.c-gakugeiinSideItem {
  display: flex;
  margin: 16px 0 10px 1px;

  &_location {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 62px;
    height: 62px;
    margin-left: 40px;
    background-color: var(--color_background_whiteblue);
    color: var(--g_color_text_888888);
    font-size: 13px;
    font-weight: bold;
    text-align: center;
  }

  &_content {
    width: 220px;
    color: var(--color_text_base);
    font-size: 14px;
    font-weight: 600;
    line-height: 1.714;
    text-align: left;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
